var stdin_default = (old, replaceObj) => ({ ...old, ...replaceObj });
export {
  stdin_default as default
};
